import { render, staticRenderFns } from "./videoPlay.vue?vue&type=template&id=6fb22cb8&scoped=true"
import script from "./videoPlay.vue?vue&type=script&lang=js"
export * from "./videoPlay.vue?vue&type=script&lang=js"
import style0 from "./videoPlay.vue?vue&type=style&index=0&id=6fb22cb8&prod&lang=scss&scoped=true"
import style1 from "./videoPlay.vue?vue&type=style&index=1&id=6fb22cb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb22cb8",
  null
  
)

export default component.exports